<template>
  <router-link
    :to="href"
    class="pravo__buttons__goBackButton"
    :class="icon"
    tag="button"
  >
    {{ text }}
  </router-link>
</template>

<script>
export default {
  name: "GoBack",
  props: {
    text: String,
    icon: String,
    href: String,
    additionalClass: {
      type: String,
      default: "",
    },
  },
};
</script>